import { render } from "./SitePromoCodes.vue?vue&type=template&id=48b17531"
import script from "./SitePromoCodes.vue?vue&type=script&setup=true&lang=js"
export * from "./SitePromoCodes.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Sites/SitePromoCodes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48b17531"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48b17531', __exports__)) {
    api.reload('48b17531', __exports__)
  }
  
  module.hot.accept("./SitePromoCodes.vue?vue&type=template&id=48b17531", () => {
    api.rerender('48b17531', render)
  })

}


export default __exports__